/**
 * @module features/devices/utils/idGenerator
 * @description Client-side helper producing a DEV-<ALPHANUMERIC> suggestion.
 * The server remains the source of uniqueness truth (it returns 409 on
 * collision); this only pre-fills the field for the "Auto-Generate" button.
 */

// No look-alike characters (0/O, 1/I) so codes are readable on hardware labels.
const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/** Generate a `DEV-XXXXXXXXXX` code using the Web Crypto CSPRNG when available. */
export function generateRegisteredDeviceId(length = 10): string {
  const bytes = new Uint8Array(length);
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  const suffix = Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join("");
  return `DEV-${suffix}`;
}
